import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import clsx from 'clsx';
import styles from './RemoveAdvanceGroupDialog.style';
import RemovingIndicator from '../RemovingIndicator';
import appStyles from '../../App.style';

const RemoveAdvanceGroupDialog = ({
  onDismiss,
  onSubmit,
  error,
  isRemoving,
  isOpen,
  className,
  ...other
}) => (
  <Dialog
    dialogContentProps={{
      type: DialogType.normal,
      title: 'Remove Advance Group',
      closeButtonAriaLabel: 'Close',
    }}
    deleteError={error}
    modalProps={{
      className: clsx(styles.root, className),
    }}
    hidden={!isOpen}
    onDismiss={onDismiss}
    onSubmit={onSubmit}
    isSubmitting={isRemoving}
    {...other}
  >
    <p>
      Deleted advance groups cannot be recovered. Do you wish to continue?
      <br />
      <br />
    </p>
    {error && (
      <span className={clsx(styles.secondaryIcon, appStyles.defaultColor)}>{error.message}</span>
    )}
    <DialogFooter>
      <DefaultButton onClick={onDismiss} disabled={isRemoving}>
        Cancel
      </DefaultButton>
      <PrimaryButton type="submit" onClick={onSubmit} disabled={isRemoving}>
        Delete
      </PrimaryButton>

      {isRemoving && <RemovingIndicator className={styles.saving} />}
    </DialogFooter>
  </Dialog>
);

RemoveAdvanceGroupDialog.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  isOpen: PropTypes.bool,
  isRemoving: PropTypes.bool,
  className: PropTypes.string,
  error: PropTypes.object,
};

RemoveAdvanceGroupDialog.defaultProps = {
  isSubmitting: false,
  isOpen: false,
  isRemoving: false,
  className: 'normal',
  error: undefined,
};

export default RemoveAdvanceGroupDialog;
